// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__rQCPh","label":"Completed_label__3kLif"};